// Detects the media source type from a URL or raw ID.
// Returns { type, id } where type is one of:
//   'youtube'  — a YouTube video (id populated), or a playlist (playlistId
//                populated; id is the video to start on, or null for the
//                playlist's first video)
//   'spotify'  — recognised but not supported yet (id null)
//   'instagram'— recognised but not supported yet (id null)
//   'unknown'  — unrecognised input
export function detectMediaSource(input) {
  if (!input) return { type: 'unknown', id: null };
  const trimmed = input.trim();
  // YouTube URL forms
  try {
    const u = new URL(trimmed);
    const list = u.searchParams.get('list');
    if (u.hostname.includes('youtube.com')) {
      const v = u.searchParams.get('v');
      if (list) return { type: 'youtube', id: v || null, playlistId: list };
      if (v) return { type: 'youtube', id: v };
    }
    if (u.hostname === 'youtu.be') {
      const id = u.pathname.slice(1);
      if (id && list) return { type: 'youtube', id, playlistId: list };
      if (id) return { type: 'youtube', id };
    }
    // Recognised-but-unsupported hosts (for the "not supported yet" message later)
    if (u.hostname.includes('spotify.com')) return { type: 'spotify', id: null };
    if (u.hostname.includes('instagram.com')) return { type: 'instagram', id: null };
  } catch {
    // Not a URL — treat as a raw YouTube video id if it looks like one (11 chars, url-safe)
    if (/^[A-Za-z0-9_-]{11}$/.test(trimmed)) return { type: 'youtube', id: trimmed };
  }
  return { type: 'unknown', id: null };
}
